import _createIconComponent from './utils/createIconComponent';
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from 'react';
const _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj)
{
	return obj && obj.__esModule ? obj :
	{
		default: obj
	};
}
const IconAddOutline = (0, _createIconComponent2.default)(
{
	content: _react2.default.createElement('g', null, _react2.default.createElement('path',
	{
		d: 'M16.954 10.5H5.944h11.01zM11.5 5.045v10.91-10.91zm10 5.455c0 5.556-4.444 10-10 10s-10-4.444-10-10 4.444-10 10-10 10 4.545 10 10z'
	})),
	height: 22,
	width: 22
});
IconAddOutline.displayName = 'IconAddOutline';
const _default = IconAddOutline;
export {_default as default};
